// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"19676f62","388":"6dc5dc02","796":"839d2bc8"}[chunkId] + ".chunk.css";
};